import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'A funny thing happened..',
  date: new Date(2023, 2, 12),
  img: '/img/drummer.jpeg',
  tracks: [
    {
      title: 'Walkins Welcome',
      src: '/songs/2023-03-12/walkins_welcome.mp3',
    },
    {
      title: 'Coasting',
      src: '/songs/2023-03-12/coasting.mp3',
    },
    {
      title: 'Easin\'',
      src: '/songs/2023-03-12/easin.mp3',
    },
    {
      title: 'Change',
      src: '/songs/2023-03-12/change.mp3',
    },
    {
      title: 'Traitor',
      src: '/songs/2023-03-12/traitor.mp3',
    },
    {
      title: 'Step Outside',
      src: '/songs/2023-03-12/step_outside.mp3',
    },
    {
      title: 'After the Rain',
      src: '/songs/2023-03-12/after_the_rain.mp3',
    },
    {
      title: 'Saxy Mess',
      src: '/songs/2023-03-12/saxy_mess.mp3',
    },
    {
      title: 'Dreamscape',
      src: '/songs/2023-03-12/dreamscape.mp3',
    },
    
    {
      title: 'Running Away',
      src: '/songs/2023-03-12/running_away.mp3',
    },
    
    
    
    
  ]
}
export default album;